module.exports = __webpack_public_path__ + "static/media/itau-unibanco@3x.7abd6ee9.jpg";